import {
  ComponentType,
  CSSProperties,
  PropsWithChildren,
  useState,
} from 'react';
import * as S from './styles';
import Image, { StaticImageData } from 'next/image';
import { useTheme } from 'styled-components';
import { IconProps } from '@/types/icon';

export type AvatarProps = PropsWithChildren<{
  $size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  $shape: 'square' | 'rounded';
  $variant: 'solid' | 'soft';
  $color: 'accent' | 'neutral' | 'error' | 'success' | 'warning' | 'info';
  $image?: string | StaticImageData;
  $imageProps?: object;
  $initials?: string;
  $initialsColor?: string;
  $Icon?: ComponentType<IconProps>;
  $iconProps?: object;
  $iconColor?: string;
  $iconSize?: number;
  $preencherFundo?: boolean;
  $style?: CSSProperties;
}>;

export function borderRadiusCalculator(tamanho: number) {
  return tamanho < 5 ? 2 : tamanho === 5 ? 3 : tamanho <= 8 ? 4 : 5;
}

export default function Avatar(props: AvatarProps) {
  const theme = useTheme();
  const {
    $image,
    $shape,
    $size,
    $imageProps = {},
    $initials = undefined,
    $initialsColor,
    $Icon,
    $iconProps = {},
    $iconColor,
    $iconSize,
    children,
    $style,
  } = props;

  const borderRadius =
    $shape === 'rounded' ? '50%' : theme.spacing[borderRadiusCalculator($size)];

  const [erro, setErro] = useState(false);

  return (
    <S.Container style={$style} $erro={erro} {...props}>
      {$image && !erro ? (
        <S.ImageWrapper {...props}>
          <Image
            onError={() => setErro(true)}
            src={$image}
            alt="Avatar"
            priority
            fill
            sizes={`${theme.spacing[$size + 4]}px`}
            style={{
              objectFit: 'cover',
              borderRadius: borderRadius,
              backgroundColor: theme.colors.neutral.neutral_alpha[3],
              ...$imageProps,
            }}
          />
          {children}
        </S.ImageWrapper>
      ) : null}
      {$Icon && $iconColor && $iconSize ? (
        <$Icon color={$iconColor} size={$iconSize} {...$iconProps} />
      ) : null}
      {$initials && $initialsColor && (!$image || erro) ? (
        <S.ImageWrapper {...props}>
          <S.Texto $color={$initialsColor} $size={$size}>
            {$initials}
          </S.Texto>
        </S.ImageWrapper>
      ) : null}
    </S.Container>
  );
}
